/* @flow */

import React from 'react';
import Styled from 'styled';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import FadingCircleView from 'lib/loaders/spinkit/fading-circle-view';
import withInnerRef from 'lib/react/with-inner-ref';
import defaultStyles from './text-input-view.scss';

@Styled(defaultStyles)
@observer
class TextInputView extends React.Component {
    static defaultProps = {
        type: 'text',
        minDynamicWidth: 30,
    };

    @observable focused = false;

    ref: ?HTMLInputElement;

    setRef = (ref: ?HTMLInputElement) => {
        this.ref = ref;
    };

    focus = () => {
        if (this.ref) {
            this.ref.focus();
        }
    };

    onFocus = event => {
        if (this.props.onFocus) {
            this.props.onFocus(event);
        }

        this.focused = true;
    };

    onBlur = event => {
        if (this.props.onBlur) {
            this.props.onBlur(event);
        }

        this.focused = false;
    };

    render() {
        const {
            id,
            label,
            type,
            loading,
            elementsBeforeInput,
            innerRef,
            invalid,
            dynamicWidth,
            value,
            intlManager,
            styles,
            minDynamicWidth,
            ...rest
        } = this.props;

        const classNames = [styles.textInput];

        if (this.focused) {
            classNames.push(styles.focused);
        }

        if (elementsBeforeInput || loading) {
            classNames.push(styles.hasElementsBefore);
        }

        let style;

        if (dynamicWidth && minDynamicWidth && value) {
            style = {
                width: minDynamicWidth + value.length * 13,
            };
        }

        const input = (
            <div className={classNames.join(' ')} onClick={this.focus}>
                {elementsBeforeInput}
                <input
                    size='1'
                    id={id}
                    key='input'
                    type={type}
                    value={value}
                    style={style}
                    autoCapitalize={'none'}
                    {...rest}
                    className={styles.input}
                    ref={this.setRef}
                    onBlur={this.onBlur}
                    onFocus={this.onFocus}
                />
                {loading ? <FadingCircleView /> : null}
            </div>
        );

        return label ? (
            <label htmlFor={id}>
                <span className={styles.label}>{label}</span>
                {input}
            </label>
        ) : (
            input
        );
    }
}

export default TextInputView;
